import { Archetype } from "../types";

export const archetypes: Archetype[] = [
  {
    id: "jaguar",
    name: "Jaguar",
    spanishName: "El Jaguar",
    description:
      "El Jaguar es un líder estratégico y decidido que inspira respeto mediante acciones calculadas y autoridad natural.",
    strengths: [
      "Visión a largo plazo y pensamiento estratégico",
      "Autoridad silenciosa y confianza",
      "Altos estándares y disciplina",
      "Capacidad para guiar a otros en la incertidumbre",
    ],
    subdescription:
      "Like the jaguar in Latino mythology—strong, sacred, and silent—you move with purpose and lead with presence. You were built to blaze trails, not follow them.",
    workStyle:
      "Esto no es solo una etiqueta de personalidad—es tu ventaja profesional. Tus fortalezas de Jaguar son exactamente lo que el mundo necesita más: mentes claras, manos firmes y un propósito inquebrantable.<br/><br/>Conocer tu arquetipo es el primer paso. Aprender a usarlo es el cambio de juego.",
    idealEnvironment:
      "Leadership roles that allow for strategic planning and decision-making authority, with clear metrics for success.",
    growthAreas: [
      "✅ A full narrative of what makes you a Jaguar",
      "✅ How to amplify your leadership style",
      "✅ Growth strategies for patience, humility, and communication",
      "✅ Best-fit job roles, industries, and team dynamics",
      "✅ A custom 12-month leadership development roadmap",
      "✅ Coaching prompts and questions to ask in interviews",
      "✅ A leadership affirmation and cultural alignment heatmap",
      "✅ Jaguar-style AI prompts for decision-making, feedback, and planning",
    ],
    careerTitle: "Ya lideras. Ahora lidera con claridad.",
    careerAdvice:
      "Te tomaste el tiempo para mirar hacia adentro—ahora es momento de avanzar. Por solo <b>$7</b>, obtén una guía estratégica completa adaptada a tu estilo único de liderazgo.",
    color: "#c62828",
    icon: "Sword",
    overallComment:
      "No eres solo un profesional. <b>Eres un Jaguar. Camina como tal. Lidera como tal.</b>",
  },
  {
    id: "condor",
    name: "Cóndor",
    spanishName: "El Cóndor",
    description:
      "Sabio. Estratégico. Centrado. Como Cóndor, ves lo que otros no ven. No te apresuras: te elevas. Lideras con reflexión, actúas con intención y aportas claridad serena incluso en los momentos más caóticos.",
    strengths: [
      "Visión a largo plazo y perspectiva",
      "Madurez emocional y presencia",
      "Paciencia estratégica",
      "Toma de decisiones con profundidad",
    ],
    subdescription:
      "Like the sacred condor of the Andes, you soar above the noise. You don’t just react—you interpret. You don’t just move—you guide.",
    workStyle:
      "No estás aquí para hacer trabajo superficial: estás aquí para construir con propósito. Tu arquetipo refleja una habilidad poco común para mantener la calma, pensar profundamente y alinear tus acciones con tus valores. Cuando otros se sienten perdidos, acuden a personas como tú.<br/><br/> Pero ser el guía visionario no significa quedarte siempre detrás de escena. El siguiente paso es aprender a liderar con tu visión... y dejarte ver.",
    idealEnvironment:
      "Roles that require strategic planning, mentorship, and organizational development.",
    growthAreas: [
      "✅ A full narrative on what it means to be a Cóndor",
      "✅ Coaching strategies to amplify your insight and leadership",
      "✅ How to turn wisdom into influence without sacrificing calm",
      "✅ Career roles and environments designed for your gifts",
      "✅ A 12-month strategic growth roadmap",
      "✅ Feedback and communication tips for quiet leaders",
      "✅ An affirmation and Latino values heatmap",
      "✅ AI prompts for strategic thinking, calm communication, and big-picture planning",
    ],
    careerTitle: "Siempre Has Visto el Panorama Completo. Ahora Úsalo Para Liderar.",
    careerAdvice:
      "Hiciste el test. Reflexionaste. Descubriste que tu fortaleza no está en la rapidez, sino en tu visión.<br/><br/>Ahora, por solo <b>$7</b>, puedes desbloquear la guía completa del Cóndor y comenzar a convertir tu sabiduría en influencia.",
    overallComment:
      "No estás aquí para perseguir. <b>Estás aquí para guiar. Élevate. Lidera como el Cóndor.</b>",
    color: "#37474f",
    icon: "Wing",
  },
  {
    id: "llama",
    name: "Llama",
    spanishName: "La Llama",
    description:
      "Leal. Con los pies en la tierra. Confiable. Como Llama, eres la calma en la tormenta—la persona en la que otros confían cuando las cosas se ponen difíciles. Lideras cumpliendo, dando seguimiento y manteniendo el rumbo cuando otros vacilan. No buscas atención. Ganas confianza.",
    strengths: [
      "Estabilidad y constancia",
      "Lealtad a las personas y al propósito",
      "Fiabilidad emocional y serenidad",
      "Una presencia tranquila que une a los equipos",
    ],
    subdescription:
      "Like the llama in Latin American culture, you carry weight with grace. You don’t need to be loud to be essential—and that’s exactly what makes you powerful.",
    workStyle:
      "Ser una Llama no significa estar al mando—significa ser indispensable. En equipos, familias y organizaciones, a menudo eres la razón por la que todo funciona. Pero no siempre recibes el reconocimiento—o la claridad—que mereces.<br/><br/>Ahora conoces tu Arquetipo LatinoTM. El siguiente paso es aprender a hacerlo tuyo.",
    idealEnvironment:
      "Team-oriented roles that value reliability, support, and cultural understanding.",
    growthAreas: [
      "✅ A full breakdown of what it means to be a Llama",
      "✅ How to use your steadiness as a superpower",
      "✅ Development strategies around voice, boundaries, and visibility",
      "✅ Ideal job titles and roles where Llamas thrive",
      "✅ A 12-month growth roadmap tailored to your style",
      "✅ Coaching tips to gain recognition and protect your energy",
      "✅ A personal affirmation and Latino values alignment heatmap",
      "✅ AI prompts just for Llamas to support routines, boundaries, and career planning",
    ],
    careerTitle: "Has estado apoyando a todos. Ahora apóyate a ti.",
    careerAdvice:
      "Hiciste el test. Respondiste con honestidad. Descubriste algo poderoso sobre quién eres.<br/><br/>Ahora es momento de profundizar—por solo <b>$7</b>. Obtén tu reporte completo, diseñado para ayudarte a crecer con la misma fortaleza y confiabilidad que das a los demás.",
    overallComment:
      "No eres solo apoyo. <b>Eres clave. Reconoce tu valor. Camina con orgullo. Sé la Llama.</b>",
    color: "#6d4c41",
    icon: "Mountain",
  },
  {
    id: "quetzal",
    name: "Quetzal",
    spanishName: "El Quetzal",
    description:
      "Creativo. Con propósito. Libre. Como Quetzal, te impulsa el significado, la expresión y el profundo deseo de vivir la vida a tu manera. No estás aquí para seguir tendencias, sino para seguir la verdad. Tu creatividad, tus valores y tu individualidad te distinguen en cualquier espacio.",
    strengths: [
      "Pensamiento original y resolución creativa de problemas",
      "Un fuerte sentido ético",
      "Profunda identidad y propósito",
      "Expresión natural y autenticidad",
    ],
    subdescription:
      "Like the sacred quetzal, you symbolize <b>freedom, beauty, and vision</b> in Latin American tradition. You don’t just do the work—you do it with heart and soul.",
    workStyle:
      "En el entorno laboral, con frecuencia se premia la conformidad, pero el mundo cambia gracias a personas como tú. El arquetipo del Quetzal nos recuerda que la autenticidad también es liderazgo. Y tu capacidad para expresar lo que otros no pueden es lo que te hace poderoso.<br/><br/>Ahora que descubriste tu arquetipo, es momento de pasar de la <b>autoconciencia al autoliderazgo.</b>",
    idealEnvironment:
      "Roles that value creativity, cultural expression, and innovative thinking.",
    growthAreas: [
      "✅ A full breakdown of the Quetzal’s power and purpose",
      "✅ Coaching insights for independent, values-driven professionals",
      "✅ How to protect your freedom without sacrificing connection",
      "✅ Career roles that align with your creativity and integrity",
      "✅ A 12-month roadmap to grow on your own terms",
      "✅ Affirmations, AI prompts, and values alignment tools",
      "✅ Guidance on how to navigate rigid systems as a free thinker",
    ],
    careerTitle: "Ya eres único. Ahora sé imparable.",
    careerAdvice:
      "Le dedicaste 15 minutos de honestidad y descubriste algo real. Ahora es momento de honrar tu individualidad con acción.<br/><br/>Por solo <b>$7</b>, obtén las herramientas, ideas y la guía diseñada para alguien con tu visión.",
    overallComment:
      "No estás aquí para encajar. Estás aquí para <b>brillar como un Quetzal.</b>",
    color: "#8e24aa",
    icon: "Feather",
  },
  {
    id: "colibri",
    name: "Colibrí",
    spanishName: "El Colibrí",
    description:
      "Ligero. Rápido. Alegre. Adaptable. Eres una explosión de energía en cada espacio al que entras. Como Colibrí, te mueves con agilidad, llevas optimismo a quienes te rodean y prosperas en entornos llenos de movimiento, personas y propósito.",
    strengths: [
      "Pensamiento y acción rápida",
      "Alta energía emocional",
      "Creatividad y rápida adaptación",
      "Capacidad para motivar equipos y conectar personas",
    ],
    subdescription:
      "Like the hummingbird in Latino culture, you are a symbol of <b>resilience, motion, and joy</b>. You make things happen—and you make people feel alive.",
    workStyle:
      "Tu naturaleza de Colibrí no es casualidad—es tu superpoder profesional. La forma en que piensas, en que te mueves y en que enciendes proyectos y personas es exactamente lo que muchos equipos y organizaciones necesitan.<br/><br/>Ahora que descubriste tu Arquetipo LatinoTM, esto es solo el comienzo.",
    idealEnvironment:
      "Dynamic roles that require quick thinking and adaptability.",
    growthAreas: [
      "✅ A deep dive into what makes you a Colibrí",
      "✅ How to leverage your strengths to grow and lead",
      "✅ Development areas and how to manage your energy",
      "✅ Career roles and environments where you’ll thrive",
      "✅ A personalized 12-month career roadmap",
      "✅ AI prompts designed just for Colibrís",
      "✅ A mantra to guide your growth",
      "✅ A heatmap of how your archetype aligns with Latino values",
    ],
    careerTitle: "¿Listo para desplegar tus alas?",
    careerAdvice:
      "Ya hiciste la parte más difícil. Te presentaste, respondiste con honestidad y descubriste algo poderoso sobre ti.<br/><br/>Ahora ve más allá. Por solo <b>$7</b>, obtén el plano completo de tu ADN profesional y úsalo para avanzar más rápido, crecer con inteligencia y liderar con alegría.",
    overallComment: "No solo estás haciendo un test. <b>Estás despegando.</b>",
    color: "#0288d1",
    icon: "Zap",
  },
  {
    id: "coqui",
    name: "Coquí",
    spanishName: "El Coquí",
    description:
      "Compasivo. Con los pies en la tierra. Leal. Como Coquí, no solo lideras con el corazón, sino que eres el corazón del equipo. Estás presente para los demás, proteges lo que importa y das seguridad emocional a quienes te rodean. Puede que no siempre seas el primero en hablar, pero tu presencia es poderosa e inolvidable.",
    strengths: [
      "Empatía profunda e inteligencia emocional",
      "Fuertes instintos para cuidar y proteger",
      "Toma de decisiones equilibrada en las relaciones",
      "Compromiso con el equipo, la familia y el propósito",
    ],
    subdescription:
      "Like the beloved coquí of Puerto Rico—small in size, mighty in spirit—you remind people that care, courage, and connection are powerful leadership traits.",
    workStyle:
      "Tu capacidad de sentir profundamente y actuar con cuidado no es una habilidad blanda—es un superpoder. En un mundo que a veces se siente apresurado y desconectado, tú eres quien lo mantiene unido. El pegamento. La calma. La conciencia.<br/><br/>Ahora que sabes que eres un Coquí, tienes una elección: quedarte en las sombras o crecer para convertirte en el líder centrado en el corazón que estás destinado a ser.",
    idealEnvironment:
      "Roles that involve community engagement, relationship building, and cultural advocacy.",
    growthAreas: [
      "✅ A full narrative on what makes the Coquí archetype so powerful",
      "✅ Coaching insights on boundaries, emotional leadership, and growth",
      "✅ How to honor your care for others without losing yourself",
      "✅ Career roles and work cultures where you’ll thrive",
      "✅ A 12-month personal and professional development roadmap",
      "✅ Grounding affirmations, AI prompts, and value alignment tools",
      "✅ Guidance for managing conflict, burnout, and people-pleasing",
    ],
    careerTitle: "Siempre apoyas a los demás. Ahora es tu turno.",
    careerAdvice:
      "Te presentaste para esto. Respondiste con honestidad. Y ahora es momento de invertir en la única persona que mantiene todo unido: <b>tú</b>.<br/><br/>Por solo <b>$7</b>, obtén una hoja de ruta diseñada para tu corazón, tus valores y tu futuro.",
    overallComment:
      "No eres solo compasivo. <b>Eres valiente. Sé el Coquí. Lidera con amor.</b>",
    color: "#00796b",
    icon: "Heart",
  },
  {
    id: "buho",
    name: "Búho",
    spanishName: "El Búho",
    description:
      "Sabio. Claro. Reflexivo. Como Búho, ves lo que otros no ven. Mantienes la calma bajo presión, piensas con precisión y te basas en tus valores. No necesitas ser el más ruidoso para ser poderoso—tu visión tranquila suele ser la voz más fuerte.",
    strengths: [
      "Pensamiento analítico y buen juicio",
      "Resolución de problemas con calma y claridad",
      "Altos estándares y atención al detalle",
      "Una presencia constante, reflexiva y analítica en la que otros confían",
    ],
    subdescription:
      "Like the owl in Latino symbolism, you represent <b>clarity, patience, and wisdom</b>. You don’t chase noise—you bring light to the dark.",
    workStyle:
      "En un mundo que premia la velocidad, tú aportas profundidad. En un mundo que celebra la reacción, tú ofreces reflexión. Eres el pensador detrás de la visión, la mente detrás de la misión. Y cuando activas por completo tu perspectiva, elevas todo lo que te rodea.<br/><br/>Ahora que descubriste tu Arquetipo LatinoTM, el siguiente paso es aprender a hacerlo tuyo—y aplicarlo con la guía completa de nuestro Reporte Premium.",
    idealEnvironment:
      "Roles that require careful analysis, planning, and risk management.",
    growthAreas: [
      "✅ A full narrative about what makes you a Búho",
      "✅ Coaching strategies for focus, expression, and strategic influence",
      "✅ Growth insights to help you speak up earlier and lead with clarity",
      "✅ Career roles and environments where your gifts shine",
      "✅ A personalized 12-month growth roadmap",
      "✅ Affirmations, AI prompts, and Latino values alignment",
      "✅ Quiet-leadership tips to increase your visibility and influence",
    ],
    careerTitle: "Siempre has tenido la visión. Ahora úsala para liderar.",
    careerAdvice:
      "Te tomaste el tiempo para reflexionar y el test confirmó lo que ya intuías: piensas en profundidad, actúas con sabiduría y lideras sin ruido. <br/><br/>Por solo <b>$7</b>, desbloquea tu plan completo y úsalo para avanzar con claridad, confianza y propósito.",
    overallComment:
      "No eres solo inteligente. <b>Eres estratégico. Lidera como el Búho.</b>",
    color: "#455a64",
    icon: "Eye",
  },
];

export const getArchetypeById = (id: string): Archetype => {
  const archetype = archetypes.find((a) => a.id === id);
  if (!archetype) {
    throw new Error(`Archetype not found: ${id}`);
  }
  return archetype;
};
